module.exports = __webpack_public_path__ + "static/media/enchanting-thumbnail.2ca42645.png";